import { AccountAspectType } from "./enums"

export const setAspectTypeMap = (type: AccountAspectType) => ({
  isCompany: type === AccountAspectType.COMPANY,
  isEmployee: type === AccountAspectType.EMPLOYEE,
  isContractor: type === AccountAspectType.CONTRACT,
  isStaff: type === AccountAspectType.STAFF,
  isNone: type === AccountAspectType.NONE,
})
